<form
  [formGroup]="form"
  (ngSubmit)="onSubmitOrganization(form)"
  #formRef="ngForm"
  [patchForm]="optionValue$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="organization"
        >
          <span class="fs-3">{{
            'organizationModule.organization' | translate
          }}</span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>
      <!-- Header -->

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="organization">
      <fieldset formGroupName="description">
        <legend class="h4" id="orgGenDescLabel">{{
          'general.description' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="descriptionVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('description')"
              />
              <label for="descriptionVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="descriptionRequired"
                checked
                formControlName="isRequired"
              />
              <label for="descriptionRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="descriptionEditable"
                formControlName="isEditable"
              />
              <label for="descriptionEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="customDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['nl']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida1"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgGenDescLabel customDescLabel flag-nl-ida1"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['en']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida1"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgGenDescLabel customDescLabel flag-en-ida1"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-ida1"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgGenDescLabel customDescLabel flag-fr-ida1"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida1"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgGenDescLabel customDescLabel flag-de-ida1"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="additionalDescription">
        <legend class="h4" id="orgAdditionalDescLabel">{{
          'organizationModule.additionalDescription' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="additionalDescriptionVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('additionalDescription')"
              />
              <label for="additionalDescriptionVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="additionalDescriptionRequired"
                formControlName="isRequired"
              />
              <label for="additionalDescriptionRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="additionalDescriptionEditable"
                formControlName="isEditable"
              />
              <label for="additionalDescriptionEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <language-inputs
              [formGroup]="additionalDescriptionFormGroup"
              [legendKey]="'general.customDescription'"
              [enableAutoTranslate]="true"
            ></language-inputs>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="abbreviation">
        <legend class="h4" id="orgOmAbbrLabel">{{
          'organizationModule.abbreviation' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="abbreviationVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('abbreviation')"
              />
              <label for="abbreviationVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="abbreviationRequired"
                checked
                formControlName="isRequired"
              />
              <label for="abbreviationRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="abbreviationEditable"
                formControlName="isEditable"
              />
              <label for="abbreviationEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="generalLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['nl']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-ida2"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOmAbbrLabel generalLabel flag-nl-ida2"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['en']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-ida2"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOmAbbrLabel generalLabel flag-en-ida2"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-ida2"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOmAbbrLabel generalLabel flag-fr-ida2"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida2"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOmAbbrLabel generalLabel flag-de-ida2"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="street">
        <legend class="h4" id="orgStreetLabel">{{
          'general.street' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('street')"
              />
              <label for="streetVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetRequired"
                formControlName="isRequired"
              />
              <label for="streetRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetEditable"
                formControlName="isEditable"
              />
              <label for="streetEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="customDescLabel2">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['nl']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-ida3"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgStreetLabel customDescLabel2 flag-nl-ida3"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['en']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-ida3"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgStreetLabel customDescLabel2 flag-en-ida3"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-ida3"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgStreetLabel customDescLabel2 flag-fr-ida3"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida3"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgStreetLabel customDescLabel2 flag-de-ida3"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="streetNumber">
        <legend class="h4" id="orgStrNumLabel">{{
          'general.houseNumber' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetNumberVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('streetNumber')"
              />
              <label for="streetNumberVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetNumberRequired"
                checked
                formControlName="isRequired"
              />
              <label for="streetNumberRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetNumberEditable"
                formControlName="isEditable"
              />
              <label for="streetNumberEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="houseNumberDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['nl']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-ida4"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgStrNumLabel houseNumberDescLabel flag-nl-ida4"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['en']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-ida4"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgStrNumLabel houseNumberDescLabel flag-en-ida4"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-ida4"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgStrNumLabel houseNumberDescLabel flag-fr-ida4"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida4"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgStrNumLabel houseNumberDescLabel flag-de-ida4"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="postbox">
        <legend class="h4" id="orgPostBoxLabel">{{
          'general.postbox' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="postboxVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('postbox')"
              />
              <label for="postboxVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="postboxRequired"
                checked
                formControlName="isRequired"
              />
              <label for="postboxRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="postboxEditable"
                formControlName="isEditable"
              />
              <label for="postboxEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="postBoxDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['nl']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-ida5"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgPostBoxLabel postBoxDescLabel flag-nl-ida5"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['en']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-ida5"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgPostBoxLabel postBoxDescLabel flag-en-ida5"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-ida5"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgPostBoxLabel postBoxDescLabel flag-fr-ida5"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida5"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgPostBoxLabel postBoxDescLabel flag-de-ida5"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="city">
        <legend class="h4" id="orgCityLabel">{{
          'general.city' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cityVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('city')"
              />
              <label for="cityVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cityRequired"
                checked
                formControlName="isRequired"
              />
              <label for="cityRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cityEditable"
                formControlName="isEditable"
              />
              <label for="cityEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="cityDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['nl']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-ida6"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCityLabel cityDescLabel flag-nl-ida6"
                    formControlName="title_nl"
                  />
                </div>
              </div>

              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['en']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-ida6"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCityLabel cityDescLabel flag-en-ida6"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-ida6"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCityLabel cityDescLabel flag-fr-ida6"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida6"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCityLabel cityDescLabel flag-de-ida6"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="zipCode">
        <legend class="h4" id="orgZipCodeLabel">{{
          'general.zipcode' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="zipCodeVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('zipCode')"
              />
              <label for="zipCodeVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="zipCodeRequired"
                checked
                formControlName="isRequired"
              />
              <label for="zipCodeRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="zipCodeEditable"
                formControlName="isEditable"
              />
              <label for="zipCodeEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="zipDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['nl']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-ida7"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgZipCodeLabel zipDescLabel flag-nl-ida7"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['en']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-ida7"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgZipCodeLabel zipDescLabel flag-en-ida7"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-ida7"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgZipCodeLabel zipDescLabel flag-fr-ida7"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida7"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgZipCodeLabel zipDescLabel flag-de-ida7"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="country">
        <legend class="h4" id="orgCountryLabel">{{
          'general.country' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="countryVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('country')"
              />
              <label for="countryVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="countryRequired"
                checked
                formControlName="isRequired"
              />
              <label for="countryRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="countryEditable"
                formControlName="isEditable"
              />
              <label for="countryEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="countryDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['nl']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-ida8"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCountryLabel countryDescLabel flag-nl-ida8"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['en']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-ida8"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCountryLabel countryDescLabel flag-en-ida8"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-ida8"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCountryLabel countryDescLabel flag-fr-ida8"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida8"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCountryLabel countryDescLabel flag-de-ida8"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="type">
        <legend class="h4" id="orgTypeLabel">{{
          'general.type' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="typeVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('type')"
              />
              <label for="typeVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="typeRequired"
                checked
                formControlName="isRequired"
              />
              <label for="typeRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="typeEditable"
                formControlName="isEditable"
              />
              <label for="typeEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="orgTypeDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida9"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgTypeLabel flag-nl-ida9"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida9"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgTypeLabel flag-en-ida9"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida9"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgTypeLabel orgTypeDescLabel flag-fr-ida9"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida9"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgTypeLabel orgTypeDescLabel flag-de-ida9"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="parentOrganisationId">
        <legend class="h4" id="orgParentOrgLabel">{{
          'general.parent' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="parentOrganisationIdVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('parentOrganisationId')"
              />
              <label for="parentOrganisationIdVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="parentOrganisationIdRequired"
                checked
                formControlName="isRequired"
              />
              <label for="parentOrganisationIdRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="parentOrganisationIdEditable"
                formControlName="isEditable"
              />
              <label for="parentOrganisationIdEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="ogrParentDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida10"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgParentOrgLabel flag-nl-ida10"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida10"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgParentOrgLabel flag-en-ida10"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida10"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgParentOrgLabel ogrParentDescLabel flag-fr-ida10"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida10"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgParentOrgLabel ogrParentDescLabel flag-de-ida10"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="commercialCode">
        <legend class="h4" id="orgComCodeLabel">{{
          'general.commercialCode' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="commercialCodeVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('commercialCode')"
              />
              <label for="commercialCodeVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="commercialCodeRequired"
                checked
                formControlName="isRequired"
              />
              <label for="commercialCodeRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="commercialCodeEditable"
                formControlName="isEditable"
              />
              <label for="commercialCodeEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="comCodeDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida11"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgComCodeLabel flag-nl-ida11"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida11"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgComCodeLabel flag-en-ida11"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida11"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgComCodeLabel comCodeDescLabel flag-fr-ida11"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida11"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgComCodeLabel comCodeDescLabel flag-de-ida11"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="organisationCode"
        ><legend class="h4" id="orgOrgCodeLabel">{{
          'organizationModule.organizationCode' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="organisationCodeVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('organisationCode')"
              />
              <label for="organisationCodeVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="organisationCodeRequired"
                checked
                formControlName="isRequired"
              />
              <label for="organisationCodeRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="organisationCodeEditable"
                formControlName="isEditable"
              />
              <label for="organisationCodeEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="orgCodeDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida12"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOrgCodeLabel flag-nl-ida12"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida12"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOrgCodeLabel flag-en-ida12"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida12"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOrgCodeLabel orgCodeDescLabel flag-fr-ida12"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida12"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOrgCodeLabel orgCodeDescLabel flag-de-ida12"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="organisationSecondaryCode">
        <legend class="h4" id="orgOrgSecCodeLabel">{{
          'organizationModule.organizationSecondaryCode' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="organisationSecondaryCodeVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('organisationSecondaryCode')"
              />
              <label for="organisationSecondaryCodeVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="organisationSecondaryCodeRequired"
                checked
                formControlName="isRequired"
              />
              <label for="organisationSecondaryCodeRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="organisationSecondaryCodeEditable"
                formControlName="isEditable"
              />
              <label for="organisationSecondaryCodeEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="orgSecDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida13"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOrgSecCodeLabel flag-nl-ida13"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida13"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOrgSecCodeLabel flag-en-ida13"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida13"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOrgSecCodeLabel orgSecDescLabel flag-fr-ida13"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida13"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgOrgSecCodeLabel orgSecDescLabel flag-de-ida13"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="phone">
        <legend class="h4" id="orgPhoneLabel">{{
          'general.phone' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="phoneVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('phone')"
              />
              <label for="phoneVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="phoneRequired"
                checked
                formControlName="isRequired"
              />
              <label for="phoneRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="phoneEditable"
                formControlName="isEditable"
              />
              <label for="phoneEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="orgPhoneDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida14"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgPhoneLabel flag-nl-id14"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida14"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgPhoneLabel flag-en-id14"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida14"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgPhoneLabel orgPhoneDescLabel flag-fr-id14"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida14"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgPhoneLabel orgPhoneDescLabel flag-de-id14"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="email">
        <legend class="h4" id="orgEmailLabel">{{
          'general.email' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="emailVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('email')"
              />
              <label for="emailVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="emailRequired"
                checked
                formControlName="isRequired"
              />
              <label for="emailRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="emailEditable"
                formControlName="isEditable"
              />
              <label for="emailEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="orgEmailDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida15"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgEmailLabel flag-nl-ida15"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida15"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgEmailLabel flag-en-ida15"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida15"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgEmailLabel flag-fr-ida15"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida15"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgEmailLabel orgEmailDescLabel flag-de-ida15"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="tertiaryCode">
        <legend class="h4" id="orgTertiaryCodeLabel">{{
          'organizationModule.tertiaryCode' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="tertiaryCodeVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('tertiaryCode')"
              />
              <label for="tertiaryCodeVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="tertiaryCodeRequired"
                checked
                formControlName="isRequired"
              />
              <label for="tertiaryCodeRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="tertiaryCodeEditable"
                formControlName="isEditable"
              />
              <label for="tertiaryCodeEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="orgTertDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida16"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgTertiaryCodeLabel flag-nl-ida16"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida16"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgTertiaryCodeLabel flag-en-ida16"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida16"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgTertiaryCodeLabel orgTertDescLabel flag-fr-ida16"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida16"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgTertiaryCodeLabel orgTertDescLabel flag-de-ida16"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="quaternaryCode">
        <legend class="h4" id="orgQuaterCodeLabel">{{
          'organizationModule.quaternaryCode' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="quaternaryCodeVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('quaternaryCode')"
              />
              <label for="quaternaryCodeVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="quaternaryCodeRequired"
                checked
                formControlName="isRequired"
              />
              <label for="quaternaryCodeRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="quaternaryCodeEditable"
                formControlName="isEditable"
              />
              <label for="quaternaryCodeEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="orgQuarDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida17"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgQuaterCodeLabel flag-nl-ida17"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida17"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgQuaterCodeLabel flag-en-ida17"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida17"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgQuaterCodeLabel orgQuarDescLabel flag-fr-ida17"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida17"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgQuaterCodeLabel orgQuarDescLabel flag-de-ida17"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="quintaryCode"
        ><legend class="h4" id="orgQuintCodeLabel">{{
          'organizationModule.quintaryCode' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="quintaryCodeVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('quintaryCode')"
              />
              <label for="quintaryCodeVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="quintaryCodeRequired"
                checked
                formControlName="isRequired"
              />
              <label for="quintaryCodeRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="quintaryCodeEditable"
                formControlName="isEditable"
              />
              <label for="quintaryCodeEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="orgQuintDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida18"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgQuintCodeLabel flag-nl-ida18"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida18"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgQuintCodeLabel flag-en-ida18"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida18"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgQuintCodeLabel orgQuintDescLabel flag-fr-ida18"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida18"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgQuintCodeLabel orgQuintDescLabel flag-de-ida18"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="website">
        <legend class="h4" id="orgWebsiteLabel">{{
          'general.website' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="websiteVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('website')"
              />
              <label for="websiteVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="websiteRequired"
                checked
                formControlName="isRequired"
              />
              <label for="websiteRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="websiteEditable"
                formControlName="isEditable"
              />
              <label for="websiteEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="orgWebDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida19"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgWebsiteLabel flag-nl-ida19"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida19"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgWebsiteLabel flag-en-ida19"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida19"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgWebsiteLabel orgWebDescLabel flag-fr-ida19"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida19"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgWebsiteLabel orgWebDescLabel flag-de-ida19"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="invoiceOrganizationId">
        <legend class="h4" id="orgInvoiceOrgLabel">{{
          'organizationModule.invoiceOrganization' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="invoiceOrganizationIdVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('invoiceOrganizationId')"
              />
              <label for="invoiceOrganizationIdVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="invoiceOrganizationIdRequired"
                checked
                formControlName="isRequired"
              />
              <label for="invoiceOrganizationIdRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="invoiceOrganizationIdEditable"
                formControlName="isEditable"
              />
              <label for="invoiceOrganizationIdEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="orgInvoiceDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida20"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgInvoiceOrgLabel flag-nl-ida20"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida20"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgInvoiceOrgLabel flag-en-ida20"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida20"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgInvoiceOrgLabel orgInvoiceDescLabel flag-fr-ida20"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida20"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgInvoiceOrgLabel orgInvoiceDescLabel flag-de-ida20"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="category">
        <legend class="h4" id="orgCatLabel">{{
          'general.category' | translate
        }}</legend>
        <div class="row g-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="categoryVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('category')"
              />
              <label for="invoiceOrganizationIdVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="categoryRequired"
                checked
                formControlName="isRequired"
              />
              <label for="categoryRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="categoryEditable"
                formControlName="isEditable"
              />
              <label for="categoryEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="orgCatDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-ida21"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCatLabel flag-nl-ida21"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-ida21"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCatLabel flag-en-ida21"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['fr']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-ida21"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCatLabel orgCatDescLabel flag-fr-ida21"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group" *ngIf="availableLanguages['de']">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-ida21"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="orgCatLabel orgCatDescLabel flag-de-ida21"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <div class="form-footer sticky-bottom">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>

  <!-- End Card -->
</form>

<form
  [formGroup]="formOrganizationDenominations"
  (ngSubmit)="onSubmitOrganization(formOrganizationDenominations)"
  #formRef="ngForm"
  [patchForm]="configFormValues$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          [attr.aria-expanded]="isCollapsedDenominations ? 'false' : 'true'"
          (click)="isCollapsedDenominations = !isCollapsedDenominations"
          type="button"
          aria-controls="organizationNaming"
        >
          <span class="fs-3">{{
            'organizationModule.organizationNaming' | translate
          }}</span>

          <i
            class="fa fa-fw"
            [ngClass]="
              isCollapsedDenominations ? 'fa-chevron-down' : 'fa-chevron-up'
            "
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div
      *ngIf="!isCollapsedDenominations"
      class="card-body"
      id="organizationNaming"
    >
      <fieldset class="mb-4">
        <legend class="form-label" id="omOrgLabel"
          >{{ 'organizationModule.organization' | translate }}
        </legend>

        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-nl"
                  role="img"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                  id="flag-nl-4"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="omOrgLabel flag-nl-4"
                formControlName="organisationDisplayNameNl"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-en"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                  id="flag-en-4"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="omOrgLabel flag-en-4"
                formControlName="organisationDisplayNameEn"
              />
            </div>
          </div>

          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-fr"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                  id="flag-fr-4"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="omOrgLabel flag-fr-4"
                formControlName="organisationDisplayNameFr"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-de"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                  id="flag-de-4"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="omOrgLabel flag-de-4"
                formControlName="organisationDisplayNameDe"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="mb-4">
        <legend class="form-label" id="omOrgsLabel"
          >{{ 'organizationModule.organizations' | translate }}
        </legend>

        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-nl"
                  role="img"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                  id="flag-nl-3"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="omOrgsLabel flag-nl-3"
                formControlName="organisationsDisplayNameNl"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-en"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                  id="flag-en-3"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="omOrgsLabel flag-en-3"
                formControlName="organisationsDisplayNameEn"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-fr"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                  id="flag-fr-3"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="omOrgsLabel flag-fr-3"
                formControlName="organisationsDisplayNameFr"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-de"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                  id="flag-de-3"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="omOrgsLabel flag-de-3"
                formControlName="organisationsDisplayNameDe"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
